import { useCallback, useEffect, useState } from "react";
import {
  accountIdsMatch,
  getStoredSelectedAccountId,
  IB_ACTIVE_ACCOUNT_CHANGED_EVENT,
} from "../Constants/accountTypes";
import { fetchOperatingAccounts } from "../Services/operatingAccountsApi";
import { isBaasExitRailVirtualAccount } from "../Services/baasVirtualShells";

/**
 * Active Carteira IB account (HomeAccountSelector / stored id).
 * Use to gate Pix key create/delete and Criar conta virtual when OTC/WALLET is selected,
 * and to scope Contas virtuais / Stables to the active entity.
 */
export const useActiveIbAccount = () => {
  const [account, setAccount] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    setLoading(true);
    try {
      const accounts = await fetchOperatingAccounts();
      const list = Array.isArray(accounts) ? accounts : [];
      const stored = getStoredSelectedAccountId();
      const selected =
        (stored != null && stored !== ""
          ? list.find((item) =>
              accountIdsMatch(item.id, stored)
              || accountIdsMatch(item.accountNumber, stored)
              || accountIdsMatch(item.raw?.account_number, stored))
          : null)
        || list.find((item) => item.raw?.set_app_active)
        || list[0]
        || null;
      setAccount(selected);
    } catch {
      setAccount(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    void refresh();
  }, [refresh]);

  useEffect(() => {
    const onChanged = () => {
      void refresh();
    };
    window.addEventListener(IB_ACTIVE_ACCOUNT_CHANGED_EVENT, onChanged);
    return () => window.removeEventListener(IB_ACTIVE_ACCOUNT_CHANGED_EVENT, onChanged);
  }, [refresh]);

  const isExitRailVirtual = Boolean(
    account
      && (isBaasExitRailVirtualAccount(account) || isBaasExitRailVirtualAccount(account.raw)),
  );

  const entityId = String(
    account?.entityId || account?.raw?.entity_id || account?.raw?.entityId || "",
  ).trim() || null;

  return {
    account,
    entityId,
    loading,
    isExitRailVirtual,
    refresh,
  };
};

export default useActiveIbAccount;
